module.exports = require("../../../node_modules/arraybuffer-loader/lib/to-array-buffer.js")("")